import {
  IUserInsReport,
  IDeltaHedgeExeCommonSearchParam,
} from "../../Interfaces/deltaHedgeExe";
import TableTemplate from "../TableTemplate/tableTemplate";
import { CommonTableUI } from "../TableTemplate/common";
import { getUserInsTable } from "../../Requests/deltaHedgeExe";

interface IProps {
  searchParams: IDeltaHedgeExeCommonSearchParam;
}
const UserInsTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeExeCommonSearchParam, IUserInsReport>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={getUserInsTable}
      searchParameters={searchParams}
    />
  );
};

export default UserInsTable;
